import Axios from '../context/axios/AxiosControl'

export const getProducts = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/product/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PRODUCT_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_NOT_LOADING'
        })
    }
}

export const getProduct = (product) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/product/get/'+ product, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PRODUCT_GET_SUCCESS',
                payload: data.product
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_NOT_LOADING'
        })
    }
}

export const addProduct = (image, productdata) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        if(image !== null && image !== undefined&& image !== '' && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: localStorage.getItem('jwt')
                }
            })
            productdata.image = data
        }else{
            productdata.image = image
        }

        const { data, status} = await Axios.post('/api/restaurant/product/register', productdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'PRODUCT_ADD_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'PRODUCT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_NOT_LOADING'
        })
    }
}

export const editProduct = (image, productdata, idProduct) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        if(image !== null && image !== undefined&& image !== '' && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: localStorage.getItem('jwt')
                }
            })
            productdata.image = data
        }else{
            productdata.image = image
        }

        const { data, status} = await Axios.put('/api/restaurant/product/edit/' + idProduct, productdata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'PRODUCT_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'PRODUCT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'
        })
    }
}

export const removeProduct = (idProduct) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status} = await Axios.delete('/api/restaurant/product/remove/' + idProduct, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'PRODUCT_REMOVE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'PRODUCT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'
        })
    }
}

export const enableProduct = (idProduct) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/product/enable/' + idProduct, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'PRODUCT_ENABLEDISABLE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'PRODUCT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'
        })
    }
}

export const disableProduct = (idProduct) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/product/disable/' + idProduct, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 263 || status === 260) {
            dispatch({
                type: 'PRODUCT_ENABLEDISABLE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'PRODUCT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'
        })
    }
}